import { Icon } from '@chakra-ui/react';

export const ChatIcon = (props: any) => (
  <Icon aria-label="chat icon" {...props}>
    <path
      d="m13 8c1.1045695 0 2 .8954305 2 2v6c0 1.1045695-.8954305 2-2 2h-3.99806107c-1.33462595 0-2.00193893.6666667-2.00193893 2-1.33333333 0-2-.6666667-2-2h-1c-1.1045695 0-2-.8954305-2-2v-6.33333333c0-.92047459.74619208-1.66666667 1.66666667-1.66666667zm7-4c1.1045695 0 2 .8954305 2 2v6c0 1.1045695-.8954305 2-2 2 0 1.3333333-.6705528 2-2.0116584 2 0-1.8571429-.5822419-1.9897959-.9154916-1.9992711l-1.07285-.0007289c-1 0-1-2 0-2h4v-5c0-.90909091 0-.99173554-.7513148-.99924869l-9.2486852-.00075131v1c0 1-2 1-2 0v-1.33333333c0-.92047459.74619208-1.66666667 1.66666667-1.66666667zm-8 6h-7c-.65748185 0-1 .4477153-1 1v4c0 .6627417.21102179 1 1 1h7c.7889782 0 1-.3372583 1-1v-4c0-.6627417-.2110218-1-1-1z"
      fill="currentColor"
    />
  </Icon>
);
